import { CapacitorCookies } from '@capacitor/core';
import React from 'react';
import MenuItem from 'reusable-components/navigation/NavigationMenuList/MenuItem';
import { isCordova } from 'utils/platform';
import useAuthStore from '~/authentication/store';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';
import { useDebugModeStore } from '~/stores/debug';
import { useInAppUpdateStore } from '~/stores/inAppUpdate';

type DebugMenuItemsProps = {};

const DebugMenuItems = (_: DebugMenuItemsProps) => {
  const navigate = useLocalizedNavigate();
  const { checkForUpdate } = useInAppUpdateStore();
  const { setDebugMode, toggleLogAnalytics } = useDebugModeStore();
  const handleClearCookies = async () => {
    if (!isCordova()) {
      alert('Clear cookies is only available on Cordova apps.');
      return;
    }
    const confirmDialog = window.confirm(
      'This will clear all cookies and log you out of the app. Are you sure you want to continue?',
    );
    if (!confirmDialog) return;

    useAuthStore.getState().logout();
    await CapacitorCookies.clearAllCookies();
    alert('Cookies cleared. You are now logged out.');
    navigate('/');
  };
  const handleDisableDebugMode = () => {
    setDebugMode(false);
  };

  const handleCheckForAppUpdates = async () => {
    await checkForUpdate({ startWhenAvailable: true, trigger: 'manual' });
  };

  const handleMoreLoggingToggle = () => {
    toggleLogAnalytics();
  };

  return (
    <>
      <MenuItem text={'Disable Debug Mode'} onClick={handleDisableDebugMode} />
      <MenuItem
        text={'Check for app updates'}
        onClick={handleCheckForAppUpdates}
      />
      <MenuItem
        text={'Toggle more logging'}
        onClick={handleMoreLoggingToggle}
      />
      {isCordova() && (
        <>
          <MenuItem text={'Clear cookies'} onClick={handleClearCookies} />
        </>
      )}
    </>
  );
};

export default DebugMenuItems;
